import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from '@/components/layout'
import { Toaster } from '@/components/Toaster'
import {
  LoginPage,
  DashboardPage,
  LeadsPage,
  LeadDetailPage,
  LeadFormPage,
  FilledFormsPage,
  JoistLeadsPage,
  CustomersPage,
  CustomerDetailPage,
  ReportsPage,
  ActivityPage,
  SettingsPage,
} from '@/pages'

function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route element={<Layout requireAuth />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/leads/new" element={<LeadFormPage />} />
          <Route path="/leads/:id" element={<LeadDetailPage />} />
          <Route path="/forms" element={<FilledFormsPage />} />
          <Route path="/joist-leads" element={<JoistLeadsPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/:id" element={<CustomerDetailPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/activity" element={<ActivityPage />} />
        </Route>

        {/* Admin-only routes */}
        <Route element={<Layout requireAuth requireAdmin />}>
          <Route path="/reports" element={<ReportsPage />} />
        </Route>

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <Toaster />
    </>
  )
}

export default App
